module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-oyster-fluted-balmoral-1.83bc125a.jpg";